module.exports = __webpack_public_path__ + "img/public_resources_vedio_matte.873727dc.png";